import React from 'react'
import TieupCell from '../TieupCell'
import NumberCell from '../NumberCell'

class TieupRow extends React.Component {

    createTieupCell(columnNumber) {
        let cellData = this.props.cellsData[columnNumber]
        let newToggleCellFunction = null
        if (this.props.toggleRowCellFunction) {
            newToggleCellFunction = () => { return this.props.toggleRowCellFunction(columnNumber) }
        }
        let tieupCell = 
        <TieupCell
            key = {columnNumber}
            cellData = { cellData }
            toggleCellFunction = { newToggleCellFunction }
        />
        return tieupCell
    }

    createNumberDisplayCell() {
        let numberDisplayCell = 
        <NumberCell key='numbersDisplayCell' isVertical='true' cellData = { this.props.shaftDisplayNumber } />
        return numberDisplayCell
    }

    createTieupCells() {
        let cellsArray = []
        for (let c=0; c < this.props.cellsCount; c++) {
            cellsArray.push(this.createTieupCell(c))
        }
        cellsArray.push(this.createNumberDisplayCell())
        return cellsArray
    }

    render() {

        return (
            <div className='reducer-tieup-row'>
                { this.createTieupCells() }
            </div>
        )
    }

}

export default TieupRow


// WEBPACK FOOTER //
// ./src/scenes/reducer/components/TieupRow/index.js